import * as actionList from '../actions/reportdeclarationsactions';
import moment from 'moment';

const state = { 
    search:'', 
    page:0, 
    startDate: moment().startOf('month').toDate(), 
    endDate: moment().endOf('month').toDate(), 
    userId:-1, 
    countryId:null, 
    status: 1,
    threepsupplier: null
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    startDate: state => state.startDate,
    endDate: state => state.endDate,
    userId: state => state.userId,
    countryId: state => state.countryId,
    status: state => state.status,
    threepsupplier: state => state.threepsupplier
};

const actions = {
    [actionList.REPORTDECLARATIONS_SEARCH]: ({ commit }, search) => {
        commit(actionList.REPORTDECLARATIONS_SEARCH, search);
    },
    [actionList.REPORTDECLARATIONS_PAGE]: ({ commit }, page) => {
        commit(actionList.REPORTDECLARATIONS_PAGE, page);
    },
    [actionList.REPORTDECLARATIONS_STARTDATE]: ({ commit }, startDate) => {
        commit(actionList.REPORTDECLARATIONS_STARTDATE, startDate);
    },
    [actionList.REPORTDECLARATIONS_ENDDATE]: ({ commit }, endDate) => {
        commit(actionList.REPORTDECLARATIONS_ENDDATE, endDate);
    },
    [actionList.REPORTDECLARATIONS_USER]: ({ commit }, userId) => {
        commit(actionList.REPORTDECLARATIONS_USER, userId);
    },
    [actionList.REPORTDECLARATIONS_COUNTRY]: ({ commit }, countryId) => {
        commit(actionList.REPORTDECLARATIONS_COUNTRY, countryId);
    },
    [actionList.REPORTDECLARATIONS_STATUS]: ({ commit }, status) => {
        commit(actionList.REPORTDECLARATIONS_STATUS, status);
    },
    [actionList.REPORTDECLARATIONS_THREEPSUPPLIER]: ({ commit }, threepsupplier) => {
        commit(actionList.REPORTDECLARATIONS_THREEPSUPPLIER, threepsupplier);
    }
};

const mutations = {
    [actionList.REPORTDECLARATIONS_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionList.REPORTDECLARATIONS_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionList.REPORTDECLARATIONS_STARTDATE]: (state, startDate) => {
        state.page = 0;
        state.startDate = startDate;
    },
    [actionList.REPORTDECLARATIONS_ENDDATE]: (state, endDate) => {
        state.page = 0;
        state.endDate = endDate;
    },
    [actionList.REPORTDECLARATIONS_USER]: (state, userId) => {
        state.page = 0;
        state.userId = userId;
    },
    [actionList.REPORTDECLARATIONS_COUNTRY]: (state, countryId) => {
        state.page = 0;
        state.countryId = countryId;
    },
    [actionList.REPORTDECLARATIONS_STATUS]: (state, status) => {
        state.page = 0;
        state.status = status;
    },
    [actionList.REPORTDECLARATIONS_THREEPSUPPLIER]: (state, threepsupplier) => {
        state.page = 0;
        state.threepsupplier = threepsupplier;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};